module.exports = __webpack_public_path__ + "static/img/huaceImg.0cf94601.png";